import $ from "jquery";
import _ from "lodash";

const photoFx = {
  ANIMATE_CLASS: "photo-list__item--animate",
  ACTIVE_CLASS: "photo-list__item--over-active",
  INACTIVE_CLASS: "photo-list__item--over-any",
  HOVER_CLASS: "photo-list__item--hover",

  /**
   * Toggle animation class on a specific
   * indexed photo, then remove after specific time.
   *
   * @param  {number} index
   */
  toggleClass(index) {
    const self = this;
    const $li = this.$photos.eq(index);

    $li.addClass(this.ANIMATE_CLASS);
    setTimeout(() => {
      $li.removeClass(self.ANIMATE_CLASS);
    }, 500);
  },

  /**
   * Returns a shuffled array of photo indexes, cut in half.
   * @return array
   */
  getShuffledIndexes() {
    const total = this.$photos.length;
    return _.chain(this.$photos)
      .map((node, index) => index)
      .shuffle()
      .slice(0, Math.floor(total / 2))
      .value();
  },

  /**
   * Init page animation for photos
   */
  initAnimations() {
    const photoIndices = this.getShuffledIndexes();
    let counter = 0;
    const self = this;

    var animateInterval = setInterval(() => {
      if (typeof photoIndices[counter] === "undefined") {
        clearInterval(animateInterval);
      } else {
        self.toggleClass(photoIndices[counter]);
      }
      counter++;
    }, 400);

    // kill the animation if we're interacting with the page.
    this.$photoList.on("mouseover", () => {
      clearInterval(animateInterval);
    });
  },

  /**
   * Toggle classes on mouseover
   */
  initMouseoverFx() {
    const self = this;
    this.$photos
      .on("mouseover", function () {
        const $this = $(this);
        $this.addClass(self.HOVER_CLASS);
        // delay to determine hover intent
        setTimeout(() => {
          if ($this.hasClass(self.HOVER_CLASS)) {
            self.$photos.not($this).addClass(self.INACTIVE_CLASS);
            $this.addClass(self.ACTIVE_CLASS);
          }
        }, 200);
      })
      .on("mouseout", () => {
        self.$photos.removeClass(
          `${self.ACTIVE_CLASS} ${self.INACTIVE_CLASS} ${self.HOVER_CLASS}`
        );
      });
  },

  /**
   * Cache a few DOM items and init FX
   */
  init() {
    this.$photoList = $(".photo-list");
    if (!this.$photoList.length) {
      return;
    }

    this.$photos = this.$photoList.find(".photo-list__item");
    this.initAnimations();
    this.initMouseoverFx();
  },
};

export default photoFx;
